import React, { useState } from 'react';
import { withTranslation, useTranslation } from "react-i18next";
import { withRouter } from "react-router";
import classNames from "classnames";
import { toast } from "react-toastify";
import { Popover } from "antd";
import "./index.scss";

import EditButtonsBlock from "./EditButtonsBlock";
import AssociatePopup from "../../containers/AssociatePopupContainer";
import SignModal from "../../components/SignModal";

import { createAction } from "../../../utils/sagaHelper";
import {
  ORDER_DELETE,
  PERFORM_ORDER_ASSOCIATING,
  ORDER_ASSISTANCE_DELETE,
  RELOAD_ORDER,
  actionUpdateOrderData,
  CHANGE_ORDER_STATE,
  LOAD_HISTORY_ORDERS,
  NEW_GROUP_REORDER, CHANGE_ORDER_STATE_WITH_SIGN,
} from '../../../store/reducers/order/order-actions';
import { actionSetSectionItemsLoading } from "../../../store/reducers/sectionsWrapperData/sectionsWrapperData-actions";
import {
  ADD_ORDER_TO_EXTERNAL_CYCLE,
  ASSOCIATE_ORDER_TO_EXTERNAL_CYCLE,
} from '../../../store/reducers/externalCycles/externalCycles-actions';


import {
  CONFIRM_DIALOG_TYPE, GLOBAL_FILTER_TYPE, ORDER_STATE, ORDER_TYPE,
} from '../../../utils/enums';
import { isAllowOrderDeleteWithoutPassword } from "../../../services/restaurant";
import { isAssistanceGroup } from "../../../services/order";
import { connect } from "react-redux";
import GlobalFilterDataService from "../../../services/globalFilterDataService.js";
import moment from 'moment';

const Actions = (props) => {
  const {
    item,
    history,
    deleteAssistanceOrder,
    deleteOrder,
    reloadOrder,
    changeOrderState,
    updateOrderData,
    associateOrder,
    associateOrdersToGroup,
    associateOrderToExternalCycle,
    addOrderToExternalCycle,
    handleOnPreviewClick,
    user,
    orders,
    historyOrders,
    sectionModel,
    loadHistoryOrders,
    setSectionItemsLoading,
    deliveryOrderWithSign,
  } = props;
  const { t } = useTranslation();
  // On phones the action icons hide behind a "⋯" toggle to keep the row narrow (evaluated once per
  // mount — a live resize listener isn't worth it for a table cell).
  const isMobileActions = typeof window !== "undefined" && window.matchMedia
    && window.matchMedia("(max-width: 900px)").matches;
  const [mobileActionsOpen, setMobileActionsOpen] = useState(false);
  const [courierConfirmDialogType, setCourierConfirmDialogType] = useState(null);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [isWithPassword, setIsWithPassword] = useState(true);
  const [showAssociatePopup, setShowAssociatePopup] = useState(false);
  const [isConfirmSignModal, setConfirmSignModal] = useState(false);

  const isAssistanceOrder = isAssistanceGroup(item.groupId);

  const getHistoryOrders = (clearHistory, hours, date) => {
    const savedFilter = GlobalFilterDataService.instance.getFilter(GLOBAL_FILTER_TYPE.orders);

    setSectionItemsLoading(true);
    loadHistoryOrders({
      ordersFilterModel: sectionModel?.filterOptions || savedFilter,
      activeOrders: orders,
      historyOrders: historyOrders,
      clearHistory: clearHistory,
      hours: hours,
      date: date,
    }).then(
      () => {
        setSectionItemsLoading(false);
      },
      () => {
        setSectionItemsLoading(false);
      }
    );
  };

  const handleOnShowConfirmDialog = (type, withPassword = true) => {
    setCourierConfirmDialogType(type);
    setShowConfirmDialog(true);
    setIsWithPassword(withPassword);
  };

  const handleOnCancelConfirmDialog = () => {
    setCourierConfirmDialogType(null);
    setShowConfirmDialog(false);
  };

  const handleOnEdit = () => {
    if (item && item.id) {
      if (isAssistanceGroup(item.groupId)) {
        history.push(`/assistance?orderId=${item.id}`, { prevUrl: "/orders" });
      } else {
        history.push(`/edit-order?orderId=${item.id}`, { prevUrl: "/orders" });
      }
    }
  };


  const handleOnConfirmDialog = token => {
    return new Promise((resolve, reject) => {
      switch (courierConfirmDialogType) {
        case CONFIRM_DIALOG_TYPE.deleteItem:
          if (isAssistanceGroup(item.groupId)) {
            deleteAssistanceOrder({ order: item, newView: true }).then(
              () => {
                resolve();
                handleOnCancelConfirmDialog();
              },
              () => {
                reject();
                handleOnCancelConfirmDialog();
              }
            );
          } else {
            deleteOrder({ order: item, token, newView: true }).then(
              () => {
                resolve();
                handleOnCancelConfirmDialog();
                getHistoryOrders(true);
              },
              () => {
                reject();
                handleOnCancelConfirmDialog();
              }
            );
          }
          break;
        case CONFIRM_DIALOG_TYPE.reload:
          reloadOrder({ id: item.id, updateOrdersPage: true}).then(
            data => {
              if (!data.order) {
                toast.error(t("orders.REWORK_ORDER_ERROR"));
              }
              resolve();
              handleOnCancelConfirmDialog();
            },
            () => {
              toast.error(t("orders.REWORK_ORDER_ERROR"));
              handleOnCancelConfirmDialog();
            }
          );
          break;
        default:
          resolve();
          break;
      }
    });
  };

  const handleOnChangeOrderState = orderState => {
    return changeOrderState({
      order: item,
      state: orderState,
    }).then(() => {
      updateOrderData({ ...item, state: orderState });
    });
  };

  const handleOnUpdateState = (orderState) => {
    if(orderState === ORDER_STATE.delivered && item.pODRequired) {
      setConfirmSignModal(true);
    } else {
      handleOnChangeOrderState(orderState);
    }
  }

  const applySignDeliveryModal = ({base64Sign}) => {
    return new Promise((resolve, reject)=> {
      deliveryOrderWithSign({order: item, base64Sign}).then(()=> {
        setConfirmSignModal(false);
        resolve();
      }, error=> {
        setConfirmSignModal(false);
        reject(error || "Error");
        toast.error(error || "Error");
      })
    })
  }

  const handleOnAssociateConfirm = (courierId, isExternalType, provider, isExternalAssignment) => {
    let data = null;
    let action = null;

    if (isExternalType) {
      action = associateOrderToExternalCycle;
      data = { provider: courierId, orderIds: [item.id] };
    } else if (isExternalAssignment) {
      action = addOrderToExternalCycle;
      data = { id: provider, orderIds: [item.id] };
    } else if (courierId === props.NEW_ASSOCIATE_GROUP_ID) {
      action = associateOrdersToGroup;
      data = { NewGroup: true, OrderIds: [item.id] };
    } else {
      action = associateOrder;
      data = { orderId: item.id, courierId, associateMode: true };
    }

    return action(data).then(() => {
      setShowAssociatePopup(false);
    });
  };

  const handleOnPreviewClickInternal = () => {
    return new Promise(resolve => {
      handleOnEdit();
      resolve();
    });
  };

  const isShowCompensation = () => {
    const dateToCheck = moment(item.date);
    const twoDaysAgo = moment().subtract(2, "days");
    const isAfter = dateToCheck.isAfter(twoDaysAgo);
    return item.type === ORDER_TYPE.delivery && isAfter;
  }

  const actionsBlock = (
    <div className={classNames({ assistance: isAssistanceOrder })}>
      <EditButtonsBlock
        withLabels={isMobileActions}
        showCompensation={isShowCompensation()}
        courierCompensation={item.courierCompensation}
        id={item.id}
        integrationType={item.integrationType}
        orderState={item.state}
        serviceNotes={item.serviceNotes}
        showConfirmDialog={showConfirmDialog}
        isWithPassword={isWithPassword}
        isAssistanceOrder={isAssistanceOrder}
        courierConfirmDialogType={courierConfirmDialogType}
        handleOnConfirmDialog={handleOnConfirmDialog}
        handleOnCancelConfirmDialog={handleOnCancelConfirmDialog}
        handleOnEdit={handleOnEdit}
        handleOnDeleteClick={() =>
          handleOnShowConfirmDialog(
            CONFIRM_DIALOG_TYPE.deleteItem,
            !isAllowOrderDeleteWithoutPassword()
          )
        }
        handleOnPreviewClick={handleOnPreviewClick || handleOnPreviewClickInternal}
        handleOnRevertClick={() =>
          handleOnShowConfirmDialog(CONFIRM_DIALOG_TYPE.reload, false)
        }
        handleOnChangeOrderState={handleOnUpdateState}
      />
    </div>
  );

  return (
    <div key={`activeOrder-${item.id}`} className={classNames("orderActions")}>
      {/* on phones the actions open as a popup menu behind the ⋯ trigger */}
      {isMobileActions ? (
        <Popover
          content={actionsBlock}
          trigger="click"
          placement="bottomRight"
          overlayClassName="orderActionsPopover"
          open={mobileActionsOpen}
          onOpenChange={setMobileActionsOpen}
        >
          <button type="button" className="actionsMoreBtn">⋯</button>
        </Popover>
      ) : actionsBlock}
      {showAssociatePopup && (
        <AssociatePopup
          isOpen={showAssociatePopup}
          courier={user}
          selectedOrderIds={[item.id]}
          associateMode={true}
          isGetControlCenters={true}
          onConfirm={handleOnAssociateConfirm}
          onClose={() => setShowAssociatePopup(false)}
        />
      )}
      {isConfirmSignModal && (
        <SignModal isOpen={isConfirmSignModal} onClose={() => setConfirmSignModal(false)} onApply={applySignDeliveryModal}/>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  restaurant: state.restaurant.data,
  user: state.userModel.data,
  orders: state.order.data.orders || [],
  historyOrders: state.order.data.historyOrders || [],
});

const mapDispatchToProps = dispatch => ({
  deleteOrder: data => dispatch(createAction(ORDER_DELETE, data)),
  deleteAssistanceOrder: data => dispatch(createAction(ORDER_ASSISTANCE_DELETE, data)),
  reloadOrder: data => dispatch(createAction(RELOAD_ORDER, data)),
  changeOrderState: data => dispatch(createAction(CHANGE_ORDER_STATE, data)),
  updateOrderData: data => dispatch(actionUpdateOrderData(data)),
  associateOrder: data => dispatch(createAction(PERFORM_ORDER_ASSOCIATING, data)),
  associateOrdersToGroup: data => dispatch(createAction(NEW_GROUP_REORDER, data)),
  associateOrderToExternalCycle: data => dispatch(createAction(ASSOCIATE_ORDER_TO_EXTERNAL_CYCLE, data)),
  addOrderToExternalCycle: data => dispatch(createAction(ADD_ORDER_TO_EXTERNAL_CYCLE, data)),
  loadHistoryOrders: data => dispatch(createAction(LOAD_HISTORY_ORDERS, data)),
  setSectionItemsLoading: data => dispatch(actionSetSectionItemsLoading(data)),
  deliveryOrderWithSign: data => dispatch(createAction(CHANGE_ORDER_STATE_WITH_SIGN, data)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Actions))
);